<template>
  <DealSticker
    v-if="productResponse?.hasDeals"
    class="my-8 w-full sm:mb-16 md:mt-0 md:!w-auto"
    :icon
  />
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import DealSticker from '~/scopes/product-core/components/presentationals/DealSticker/DealSticker.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'

defineProps<{
  icon?: Component
}>()

const { data: productResponse } = useFetchProduct()
</script>
